:host {
  display: flex;
  flex: 1;
}

web-chat {
  display: flex;
  flex: 1;
}
/* this is for webchat npm   */
.isometrik-quickchat {
   box-shadow: 0px 0px 20px 1px #6294a926;
   display: flex;
   height: 100%;
   width: 100%;
   flex:1;
 }

 /* this is for webchat website */
/* .isometrik-quickchat {
  box-shadow: 0px 0px 20px 1px #6294a926;
  display: flex;
  height: 100dvh;
  width: 100%;
} */

.chat-sidebar-container {
  width: 40%;
  min-width: var(--sidebar-width);
  transition: all 0.3s ease;
  border-right: 1px solid var(--bg-secondary-color);
  display: flex;
  flex-direction: row;
  background-color: var(--bg-primary-color);
}
.chat-sidebar-right {
  width: 30%;
  min-width: var(--sidebar-width);
  transition: all 0.3s ease;
  border-right: 1px solid var(--bg-secondary-color);
}
.loaderoverlay {
  width: 100%;
  position: absolute;
  margin: auto;
  background: rgb(0, 0, 0, 0.3);
  z-index: 1400;
}
.sidebar-tab {
  width: 100%;
  background-color: var(--bg-primary-color);
}
/* for website  */
/* .chat-body-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  background-color: var(--bg-secondary-color);
} */

/* for npm */
.chat-body-container {
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  background-color: var(--bg-secondary-color);
  width: 100%;
}

.noChatSelectedPlaceholder {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-direction: column;
  gap: 5px;
}
.noChatSelectedPlaceholder span:nth-child(2) {
  font-size: 24px;
  font-weight: 700;
  margin-top: 20px;
}
.noChatSelectedPlaceholder span:nth-child(3) {
  font-size: 16px;
  text-align: center;
}
.loadingPlaceholder {
  height: 100%;
  width: 100%;
  z-index: 12839283;
}

.back-button {
  display: none;
  padding: 0px;
  background: none;
  border: none;
  cursor: pointer;
  align-items: center;
  gap: 4px;
}

spinner-loader {
  display: flex;
  height: 100dvh;
}
.blockMessageContainer {
  text-align: center;
  padding: 20px 0px;
  margin: 0px;
  background-color: var(--bg-secondary-color);
}
@media (max-width: 768px) {
  .isometrik-quickchat {
    position: relative;
    overflow: hidden;
  }
  .chat-sidebar-right {
    width: 100%;
    position: fixed;
    z-index: 10;
    transition: all 0.3s ease;
    border-right: 1px solid var(--bg-secondary-color);
  }

  .chat-sidebar-container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(0);
    transition: transform 0.3s ease;
    z-index: 2;
    min-width: 100% !important;
  }
  .chat-sidebar-container.hidden {
    transform: translateX(-100%);
  }

  .chat-body-container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1;
  }

  .chat-body-container.hidden {
    transform: translateX(0);
  }

  .chat-body-container.show {
    transform: translateX(0);
    z-index: 3;
  }

  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 3rem;
    z-index: 10;
    top: 2.3rem;
  }
}

/* Tablet Media Queries */
@media (min-width: 769px) and (max-width: 1024px) {
  .isometrik-quickchat {
    position: relative;
    overflow: hidden;
  }
  
  .chat-sidebar-right {
    width: 100%;
    position: fixed;
    z-index: 10;
    transition: all 0.3s ease;
    border-right: 1px solid var(--bg-secondary-color);
  }

  .chat-sidebar-container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(0);
    transition: transform 0.3s ease;
    z-index: 2;
    min-width: 100% !important;
  }
  
  .chat-sidebar-container.hidden {
    transform: translateX(-100%);
  }

  .chat-body-container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1;
  }

  .chat-body-container.hidden {
    transform: translateX(0);
  }

  .chat-body-container.show {
    transform: translateX(0);
    z-index: 3;
  }

  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 3rem;
    z-index: 10;
    top: 2.3rem;
  }
}
